import { Bot, Brain, Coins, Cpu, Database, Microscope, Phone, Radio, Sparkles } from 'lucide-react';

export const products = [
  {
    title: 'SELF Phone',
    description:
      'The Resonatia mesh node in your pocket — download models, sync to the network, and earn ESSENCE when API requests are processed through your device.',
    icon: Phone,
    color: {
      bg: 'bg-white/5',
      text: 'text-white/75',
      gradient: 'bg-white/5',
    },
    features: [
      'Resonatia Mesh Node',
      'Model Download & Sync',
      'ESSENCE API Rewards',
      'AuRA Protocol & Aura Shield',
    ],
  },
  {
    title: 'Robotics',
    description:
      'Humanoid and quadruped robots — SELF Bot X1, SELF Bot P1, SELF Dog P1, and SELF Dog E1.',
    icon: Bot,
    color: {
      bg: 'bg-white/5',
      text: 'text-white/75',
      gradient: 'bg-white/5',
    },
    features: [
      'SELF Bot X1 & P1 humanoids',
      'SELF Dog P1 & E1 platforms',
      'AI agent integration',
      'Custom deployment packages',
    ],
  },
  {
    title: 'BLOOD',
    description:
      'Bio-nanotechnology for humanoid robots and advanced compute — $5,000 evaluation deposit starts your licensing partnership.',
    icon: Microscope,
    color: {
      bg: 'bg-white/5',
      text: 'text-white/75',
      gradient: 'bg-white/5',
    },
    features: [
      'Bio-nanotechnology Integration',
      'Enhanced Synaptic Plasticity',
      'Quantum-level Processing',
      'Advanced Memory Systems',
    ],
  },
  {
    title: 'Role Model AI',
    description:
      'Concierge 2.3 — photorealistic talking avatars from your portrait. Talk face-to-face, connect tools, or embed on your site.',
    icon: Brain,
    color: {
      bg: 'bg-white/5',
      text: 'text-white/75',
      gradient: 'bg-white/5',
    },
    features: [
      'Photorealistic Avatars',
      'Live Video Chat',
      'Tools & Connections',
      'Website Embed (Expert)',
    ],
  },
  {
    title: 'Cerebral OS',
    description:
      'Open-source AI IDE — agent chat, local models, integrated terminal, and optional thought-assisted control. AGPL-3.0 on GitHub.',
    icon: Cpu,
    color: {
      bg: 'bg-white/5',
      text: 'text-white/75',
      gradient: 'bg-white/5',
    },
    features: [
      'Open Source (AGPL-3.0)',
      'Local & Cloud Model Providers',
      'Agent Chat & Terminal',
      'Manual, Hybrid & Neural Modes',
    ],
  },
  {
    title: 'Resonatia',
    description:
      'The fastest, most affordable AI API — hundreds of edge-optimized models through one unified mesh API. Host models and earn ESSENCE.',
    icon: Radio,
    color: {
      bg: 'bg-white/5',
      text: 'text-white/75',
      gradient: 'bg-white/5',
    },
    features: [
      'Unified LLM & Vision API',
      'Edge-Optimized Models',
      'Global Decentralized Mesh',
      'Host & Earn ESSENCE',
    ],
  },
  {
    title: 'Essence',
    description:
      'SELF OS stablecoin on Base — node rewards, agent payments, Talk conversion, and a treasury rail toward USDC.',
    icon: Coins,
    color: {
      bg: 'bg-white/5',
      text: 'text-white/75',
      gradient: 'bg-white/5',
    },
    features: [
      'Self OS phone rewards',
      'Agent settlement on Base',
      'Concierge Talk conversion',
      'Treasury rail toward USDC',
    ],
  },
  {
    title: 'Living Website',
    description:
      'Your own site-aware AI ambassador — visitors talk to your avatar while pages open in sync. Lite from $3,500 setup + $299/mo.',
    icon: Sparkles,
    color: {
      bg: 'bg-white/5',
      text: 'text-white/75',
      gradient: 'bg-white/5',
    },
    features: [
      'Lite & Pro plans',
      'Role Model AI avatar',
      'Site-aware navigation (Pro)',
      'Stripe checkout',
    ],
  },
  {
    title: 'AuRA Resonant Layer',
    description:
      'Resonant middleware that turns music, video, and livestreams into permission-gated AI workflow signals — try Harmony Encoder Studio.',
    icon: Database,
    color: {
      bg: 'bg-white/5',
      text: 'text-white/75',
      gradient: 'bg-white/5',
    },
    features: [
      'Harmony Encoder Studio',
      'Permission-Gated Workflows',
      'Signal Inspect & Encode',
      'Proof Receipts & Opt-In Nodes',
    ],
  },
];
